import {Component} from '@angular/core';
import {ReactiveFormsModule} from "@angular/forms";

import {AngularEditorComponent} from "../../../editor/angular-editor/angular-editor.component";
import {FIELD_VIEW_PROVIDERS, FieldsBaseComponent} from "../fields-base/fields-base.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";

@Component({
    selector: 'app-alert-field',
    imports: [
    FieldsBaseComponent,
    ReactiveFormsModule,
    AngularEditorComponent,
    FaIconComponent
],
    templateUrl: './alert-field.component.html',
    styleUrl: './alert-field.component.scss',
    viewProviders: FIELD_VIEW_PROVIDERS
})
export class AlertFieldComponent extends FieldsBaseComponent<string> {
}
